import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=dbe8bcaa&scoped=true&"
import script from "./detailModal.vue?vue&type=script&lang=js&"
export * from "./detailModal.vue?vue&type=script&lang=js&"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=dbe8bcaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe8bcaa",
  null
  
)

export default component.exports